import { useBookingDesk } from '@providers'
import { useFloor } from '@providers/mapProvider'
import useSettings from '../../Settings/hooks/useSettings'

export default function useBookingCalendar() {
  const { hourlyBookingEnabled, dailyBookingEnabled, enableRecurringBookings } = useSettings()
  const floor = useFloor()
  const { recurrence, updateBookingDate, setRecurredBooking } = useBookingDesk()
  const timezone = floor.map?.building.timezone || ''
  const allDaySetting = dailyBookingEnabled && !hourlyBookingEnabled

  return {
    recurringSetting: enableRecurringBookings,
    allDaySetting,
    timezone,
    recurrence,
    updateBookingDate,
    setRecurredBooking,
  }
}
